import PolygonBase from './PolygonBase';
import shapeDiamond from '../assets/icons/shapeDiamond.svg';
import { svgToIcon } from '../utils/svg';

class ShapeDiamond extends PolygonBase {
  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const horizontalBound = width / 6;
    const verticalBound = height / 6;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  static renderIcon() {
    return svgToIcon(shapeDiamond);
  }

  static pathString() {
    return `
      M 0 -0.5
      L 0.5 0
      L 0 0.5
      L -0.5 0
      Z
    `;
  }
}

export default ShapeDiamond;
